/**
 * 生成唯一标识
 */
export function getRandomKey(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // tslint:disable-next-line:no-bitwise
        const r = (Math.random() * 16) | 0,
            // tslint:disable-next-line:no-bitwise
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * 判断用户信息是否完善
 */
export function judgeInfo(state: any) {
    let writeCount = 0;
    const birthday = state!.birthday,
        email = state!.email,
        nickName = state!.nickName,
        mobile = state!.mobile,
        gender = state!.gender,
        interestsValueArr = state!.interestsValueArr,
        realName = state!.realName,
        politicalStatus = state!.politicalStatus,
        highestEducation = state!.highestEducation,
        majorField = state!.majorField,
        professionalTitle = state!.professionalTitle,
        idiotGraph = state!.idiotGraph,
        homeTownValue = state!.homeTownValue;
    if (birthday) {
        writeCount += 1;
    }
    if (email) {
        writeCount += 1;
    }
    if (nickName) {
        writeCount += 1;
    }
    if (mobile) {
        writeCount += 1;
    }
    if (gender !== 0) {
        writeCount += 1;
    }
    if (interestsValueArr?.length > 0) {
        writeCount += 1;
    }
    if (realName) {
        writeCount += 1;
    }
    if (politicalStatus?.tagName) {
        writeCount += 1;
    }
    if (highestEducation?.tagName) {
        writeCount += 1;
    }
    if (majorField?.tagName) {
        writeCount += 1;
    }
    if (professionalTitle?.tagName) {
        writeCount += 1;
    }
    if (idiotGraph) {
        writeCount += 1;
    }
    if (homeTownValue?.length > 0) {
        writeCount += 1;
    }
    return writeCount;
}
